export const stateAbbreviationMap: { [key: string]: string } = {
    Montana: 'MT',
    Idaho: 'ID',
    Washington: 'WA',
    Oregon: 'OR',
    Wyoming: 'WY',
};
